import React, { useEffect, useReducer } from "react";
import { useHistory } from "react-router-dom";
import "./Privacy.css";
import {
  Toastify,
  handleTextChange,
  isAdmin,
  reducer,
  type,
} from "../helper/Constant";
import PolicyCard from "./PolicyUtils/PolicyCard";
import PolicyStats from "./PolicyUtils/PolicyStats";
import PolicyCompliance from "./PolicyUtils/PolicyCompliance";

import { Loader } from "../svg";
import { getPrivacyPolicy } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";

const initialState = {
  openAddEditPrivacyModal: false,
  openDeletePrivacyModal: false,
  uploadFile: "",
  uploadFileErrorMsg: "",
  title: "",
  uploadFileErrorMsg: "",
  title: "",
  titleErrorMsg: "",
  department: "",
  departmentErrorMsg: "",

  icon: "",
  description: "",
  descriptionErrorMsg: "",
  status: "",
  statusErrorMsg: "",
  toAddOrEdit: "",
  resMsg: false,
  successMessage: "",
  resFailMsg: false,
  responseMessage: "",
  miniLoader: false,
  privacyList: [],
  activeFilter: localStorage.getItem('privacyActiveFilter') || "Active",
  viewMode: "grid"
};

const Policies = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const history = useHistory();

  const {
    openAddEditPrivacyModal,
    uploadFile,
    uploadFileErrorMsg,
    title,
    titleErrorMsg,
    department,
    departmentErrorMsg,

    icon,
    description,
    descriptionErrorMsg,
    status,
    statusErrorMsg,
    toAddOrEdit,
    resMsg,
    successMessage,
    resFailMsg,
    responseMessage,
    miniLoader,
    privacyList,
    activeFilter,
    viewMode
  } = state;

  const handleOpenAddEditModal = (e) => {
    history.push("/policies/add");
  };

  const [signedPolicies, setSignedPolicies] = React.useState([]);

  const getPolicyList = () => {
    dispatch({ type: type, payload: { miniLoader: true } });
    getPrivacyPolicy()
      .then((res) => {
        dispatch({ type: type, payload: { miniLoader: false } });
        const { status, resData } = ResponseFilter(res);
        if (status) {
          dispatch({
            type: type,
            payload: {
              privacyList: resData.list,
            },
          });
          closeModal();
        }
      })
      .catch((error) => {
        dispatch({
          type: type,
          payload: {
            resFailMsg: true,
            responseMessage: error.message || "Unknown error occurred",
            miniLoader: false,
          },
        });
      });
  };

  const fetchSignedPolicies = () => {
    const empId = localStorage.getItem("employeeId");
    if (empId) {
      import("../../config/services/employeeServices").then(({ getComplianceList }) => {
        getComplianceList(`userId=${empId}&count=1000`)
          .then(res => {
            if (res.data.statusCode === 1) {
              // Extract policy IDs that are signed (status 1)
              const signedIds = res.data.responseData.list
                .filter(item => item.status === 1)
                .map(item => item.policy._id);
              setSignedPolicies(signedIds);
            }
          })
          .catch(console.error);
      });
    }
  };

  useEffect(() => {
    getPolicyList();
    if (isAdmin !== "1" && isAdmin !== "4") {
      fetchSignedPolicies();
    }
  }, []);

  const closeModal = () => {
    dispatch({
      type: type,
      payload: {
        openAddEditPrivacyModal: false,
        openDeletePrivacyModal: false,
        uploadFile: "",
        uploadFileErrorMsg: "",
        title: "",
        titleErrorMsg: "",
        department: "",
        departmentErrorMsg: "",

        icon: "",
        description: "",
        descriptionErrorMsg: "",
        status: "",
        statusErrorMsg: "",
        toAddOrEdit: "",
        miniLoader: false,
      },
    });
  };
  const handleFilterChange = (filter) => {
    localStorage.setItem('privacyActiveFilter', filter);
    dispatch({
      type: type,
      payload: {
        activeFilter: filter,
      },
    });
  };

  const handleViewModeChange = (mode) => {
    dispatch({
      type: type,
      payload: {
        viewMode: mode
      }
    });
  };

  const getIconForDepartment = (dept) => {
    if (!dept) return "fa-file-text-o";
    const lowerDept = dept.toLowerCase();

    if (lowerDept.includes("hr") || lowerDept.includes("human")) return "fa-users";
    if (lowerDept.includes("it") || lowerDept.includes("tech") || lowerDept.includes("dev")) return "fa-laptop";
    if (lowerDept.includes("finance") || lowerDept.includes("account")) return "fa-money";
    if (lowerDept.includes("sales") || lowerDept.includes("market")) return "fa-line-chart";
    if (lowerDept.includes("legal") || lowerDept.includes("law")) return "fa-gavel";
    if (lowerDept.includes("security")) return "fa-shield";

    return "fa-file-text-o";
  };

  const handleDepartmentChange = (e) => {
    const { value } = e.target;
    const suggestedIcon = getIconForDepartment(value);

    dispatch({
      type: type,
      payload: {
        department: value,
        icon: suggestedIcon,
        departmentErrorMsg: ""
      }
    });
  };

  const getFilteredPolicies = () => {
    if (!privacyList) return [];

    // If not admin, always return Active policies regardless of filter state (though UI hides filter)
    if (isAdmin !== "1" && isAdmin !== "4") {
      return privacyList.filter(p => p.status === 1 || p.status === "1");
    }

    switch (activeFilter) {
      case "Active":
        return privacyList.filter(p => p.status === 1 || p.status === "1");
      case "Drafts":
        return privacyList.filter(p => p.status === 2 || p.status === "2");
      case "Archived":
        return privacyList.filter(p => p.status === 3 || p.status === "3");
      default: // "All"
        return privacyList;
    }
  };

  const filteredPolicyList = getFilteredPolicies();

  return (
    <div className="body_container cm_bold">
      {miniLoader && <Loader />}
      <Toastify
        resMsg={resMsg}
        resMsgFail={resFailMsg}
        text={successMessage}
        responseMessage={responseMessage}
      />

      <h3 className="mb-4">COMPANY POLICIES</h3>

      {(isAdmin === "1" || isAdmin === "4") && (
        <div className="d-flex justify-content-end mb-3">
          <div className="policy-filter-group">
            <button className={`btn btn-light ${activeFilter === 'All' ? 'active' : ''}`} onClick={() => handleFilterChange('All')}>All</button>
            <button className={`btn btn-light ${activeFilter === 'Active' ? 'active' : ''}`} onClick={() => handleFilterChange('Active')}>Active</button>
            <button className={`btn btn-light ${activeFilter === 'Drafts' ? 'active' : ''}`} onClick={() => handleFilterChange('Drafts')}>Drafts</button>
            <button className={`btn btn-light ${activeFilter === 'Archived' ? 'active' : ''}`} onClick={() => handleFilterChange('Archived')}>Archived</button>
            <button className={`btn btn-light ${activeFilter === 'Compliance' ? 'active' : ''}`} onClick={() => handleFilterChange('Compliance')}>Compliance</button>
          </div>
        </div>
      )}

      {/* Stats Section */}
      {(isAdmin === "1" || isAdmin === "4") && activeFilter !== 'Compliance' && (
        <PolicyStats
          totalPolicies={privacyList.length}
          activePolicies={privacyList.filter(p => p.status === 1 || p.status === "1").length}
          draftsPending={privacyList.filter(p => p.status === 2 || p.status === "2").length}
          archivedPolicies={privacyList.filter(p => p.status === 3 || p.status === "3").length}
        />
      )}

      {activeFilter !== 'Compliance' && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="section-title">{(isAdmin === "1" || isAdmin === "4") ? activeFilter : "Active"} Policies</h4>
          <div className="view-toggle">
            <i
              className={`fa fa-th-large mr-3 change-cursor ${viewMode === 'grid' ? 'text-primary' : 'text-muted'}`}
              onClick={() => handleViewModeChange('grid')}
            ></i>
            <i
              className={`fa fa-list change-cursor ${viewMode === 'list' ? 'text-primary' : 'text-muted'}`}
              onClick={() => handleViewModeChange('list')}
            ></i>
          </div>
        </div>
      )}

      {activeFilter === 'Compliance' ? (
        <PolicyCompliance />
      ) : (
        <PolicyCard
          policyList={filteredPolicyList}
          getPolicyList={getPolicyList}
          title={title}
          titleErrorMsg={titleErrorMsg}
          handleChange={(e) => handleTextChange({ e, dispatch })}
          dispatchProps={dispatch}
          signedPolicies={signedPolicies}
          onPolicySigned={fetchSignedPolicies}
          isAdmin={isAdmin}
          activeFilter={activeFilter}
          viewMode={viewMode || 'grid'}
          handleOpenAddEditModal={handleOpenAddEditModal}

          department={department}
          departmentErrorMsg={departmentErrorMsg}

          icon={icon}
          description={description}
          descriptionErrorMsg={descriptionErrorMsg}
          status={status}
          statusErrorMsg={statusErrorMsg}
          uploadFile={uploadFile}
          uploadFileErrorMsg={uploadFileErrorMsg}
          handleDepartmentChange={handleDepartmentChange}
        />
      )}


    </div >
  );
};

export default Policies;
